<template>
  <!-- Activation 2FA forcée (rôle à 2FA obligatoire, cf. TWOFA_REQUIRED_ROLES).
       Page plein écran : aucune barre, aucun widget → aucun appel API hors
       /auth/2fa/setup/*, les seuls que le token de configuration autorise
       (un autre appel ferait 401 et l'intercepteur axios purgerait la session). -->
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-2fa-setup">
    <div class="vx-col sm:w-full md:w-3/4 lg:w-2/3 xl:w-1/2 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="px-8 pt-8 pb-6">
            <h4 class="mb-3">Set up two-factor authentication</h4>
            <vs-alert color="warning" icon-pack="feather" icon="icon-shield" :active="true" class="mb-4">
              Your role requires two-factor authentication before you can use XYLO.
              You have 15 minutes to complete this step.
            </vs-alert>
            <p v-if="email" class="text-sm text-grey mb-4">Signed in as <strong>{{ email }}</strong></p>

            <TwoFASetupSteps
              @activated="onActivated"
              @done="onDone"
              @session-expired="onSessionExpired" />

            <div class="mt-6 text-sm">
              <a href="#" @click.prevent="backToLogin">Cancel and sign in as a different user</a>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import TwoFASetupSteps from '@/components/twofa/TwoFASetupSteps.vue'
import { TWOFA_SETUP_FLAG, LOGIN_NOTICE_KEY } from '@/helpers/roleAccess.js'

const SESSION_KEYS = [
  'accessToken', 'login-id', 'login-username', 'login-avatar', 'login-email',
  'login-roles', 'login-language', 'login-broker', 'login-date', TWOFA_SETUP_FLAG
]

export default {
  name: 'TwoFASetup',
  components: { TwoFASetupSteps },
  data () {
    return {
      email: localStorage.getItem('login-email') || '',
      payload: null
    }
  },
  created () {
    // Sans token de configuration (lien ouvert à froid, session purgée) : login.
    if (!localStorage.getItem('accessToken')) {
      this.$router.push('/pages/login').catch(() => {})
    }
  },
  methods: {
    onActivated (payload) {
      // Full auth payload (id, roles, accessToken, …) + recoveryCodes.
      this.payload = payload
    },
    onDone () {
      if (!this.payload || !this.payload.accessToken) return this.backToLogin()
      this.$store.dispatch('auth/completeTwofaSetup', this.payload)
    },
    onSessionExpired () {
      localStorage.setItem(LOGIN_NOTICE_KEY, 'twofa_setup_expired')
      this.backToLogin()
    },
    backToLogin () {
      SESSION_KEYS.forEach(k => localStorage.removeItem(k))
      this.$router.push('/pages/login').catch(() => {})
    }
  }
}
</script>
